import i18n from 'src/i18n';

const configTable = () => {
  const tableColumns = [
    {
      prop: 'business',
      label: i18n.t('common_words.company'),
      minWidth: 150,
      sortable: true,
      formatter: (row) => {
        return `${row.business.name}`;
      },
    },
  ];

  return { tableColumns };
};
export default configTable;
